import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-75a12f3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-bg-portal" }

import SideBarLeft from '@/components/PortalComponents/SideBarLeft.vue';
    import { onMounted } from 'vue';
    import ChatComponent from '@/components/PortalComponents/ChatComponent.vue';

    //Import de las stores
    import { useSalesStore } from '@/stores/sales';
    import { usePayrollStore } from '@/stores/payroll';
    import { useShoppingStore } from '@/stores/shopping';
    import { useInventoryStore } from '@/stores/inventory';
    import { useThirdPartiesStore } from '@/stores/thirdParties';


    
export default /*#__PURE__*/_defineComponent({
  __name: 'PortalView',
  setup(__props) {

    onMounted(() => {
        useSalesStore().fetchDataList();
        usePayrollStore().fetchDataList();
        useShoppingStore().fetchDataList();
        useInventoryStore().fetchDataList();
        useThirdPartiesStore().fetchDataList();
        console.log("Cargadas las stores")

        /* //Llenado de datos de prueba
        useSalesStore().devFillerData()
        usePayrollStore().devFillerData()
        useShoppingStore().devFillerData()
        useInventoryStore().devFillerData()
        useThirdPartiesStore().devFillerData()
        */
    })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(SideBarLeft),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode(ChatComponent)
  ], 64))
}
}

})